import query from '@/components/query/query-constructor';
import { reportSearchUrlParams } from '@/store/reportColumns/report-search-params';

export const pushURL = (ctx: any, cb?: any, additionalRepportParams?: any) => {
  if (ctx.$route.name !== 'app.report')
    return;
  const groupBy = ctx.$route.params.type;

  const {
    filterHaving,
    filterHavingOptions,
    filterHavingValues } = ctx.$store.getters.reportParams;

  const { order, columns } = ctx.$store.getters.savedColumnsInCurentPreset[groupBy];

  const searchParams = reportSearchUrlParams(ctx.$store.getters.tableQuerySearch)

  const {
    view,
    treeLevels,
    tree,
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
    status,
  } = ctx.$store.getters.tableQueryForCurrentTab;

  const { reportBoostEnabled } =  ctx.$store.state.table

  const data = query.get({
    ...order,
    columns,
    groupBy,
    treeLevels,
    tree,
    view,
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    filterHaving,
    filterHavingOptions,
    filterHavingValues,
    currency,
    limit,
    status,
    reportBoostEnabled,
    offset: offset[groupBy],
    ...searchParams,
  });

  const drill = additionalRepportParams
    ? query.decode({
        ...query.decode(ctx.$route.params.report),
        ...additionalRepportParams
      })
    : ctx.$route.params.report;

  if (groupBy !== 'undefined' && data !== ctx.$route.params.data) {
    ctx.$router.replace({
      name: 'app.report',
      params: {
        type: groupBy,
        data: data,
        report: drill,
        manual: true,
        picker: true
      }
    }, cb, cb);
  } else {
    if(cb) {
      cb();
    }
  }
};
